import React, { useEffect } from 'react';
import { useHistory } from 'react-router';
import { Button } from '../../ui/button/Button';

//GraphQL
import { getAdminClient } from '../../layout/admin/AdminApolloClient';
import { gql, useLazyQuery, useMutation, useQuery } from '@apollo/client';

const client = getAdminClient();

export const LogOutButton = () => {

    const history = useHistory();

    const [logout, { data, loading, error }] = useMutation(
        gql`
          mutation logout {
            logout
          }
        `,
        { client }
    );

    useEffect(() => {
        if (data?.logout) {
            history.push('/admin');
        }
    }, [data]);

    const OnClick = () => {
        //sessionStorage.clear();
        //history.push('/admin');

        logout();
    };

    return (<Button type="primary" onClick={OnClick} colorTheme="gray">
        Logg ut!
    </Button>);
};